import { atom } from 'recoil';

const CalendarOpenState = atom({
    key: 'calendarOpenState',
    default: false
});

export default CalendarOpenState;